export enum URL_PARAMS_KEYS {
  TO_BE_ADDED_CATEGORY_LOCK_ID = "toBeAddedCategoryLockId",
  TO_BE_ADDED_CATEGORY_LOCK_NAME = "toBeAddedCategoryLockName",
}
